<script>
import { mapStores } from "pinia";

import TgTooltip from "@/abc-dsk/components/Tooltip/TgTooltip.vue";
import { LEVEL_EXPERT, LEVEL_INTERMEDIATE } from "@/common/level-types";
import { useSettingsStore } from "@/stores";

export default {
  name: "InflectionSchemeTabs",
  components: { TgTooltip },
  props: {
    tabs: {
      type: Array,
      required: true
    },
    activeTab: {
      type: String,
      required: true
    }
  },
  emits: ["showTab"],
  computed: {
    ...mapStores(useSettingsStore),

    wordclassLevel() {
      return this.settingsStore.activeWordClassLevel;
    }
  },
  methods: {
    showTab(name) {
      this.$emit("showTab", name);
    },
    shouldShowTooltip(text) {
      return this.wordclassLevel === LEVEL_INTERMEDIATE && text;
    },
    shouldShowLatinText() {
      return this.wordclassLevel === LEVEL_EXPERT;
    }
  }
};
</script>

<template>
  <div class="inflection-scheme-modal__tabs">
    <template v-for="tab in tabs" :key="tab.key">
      <TgTooltip
        :margin-bottom="3"
        :text="tab.labels.latinAsComment"
        :tooltip-container-class="{
          'inflection-scheme-modal__tab-tooltip--hidden': !shouldShowTooltip(
            tab.labels.latinAsComment
          )
        }"
        class="inflection-scheme-modal__tab-tooltip"
      >
        <button
          class="inflection-scheme-modal__tab-button"
          :class="{ 'inflection-scheme-modal__tab-button--active': tab.key === activeTab }"
          @click="showTab(tab.key)"
        >
          <span>
            {{ shouldShowLatinText() ? tab.labels.latin : tab.labels.danish }}
          </span>
        </button>
      </TgTooltip>
    </template>
  </div>
</template>
